import type { DateType } from '@/js/libs/api-helpers';
import { toDateType } from '@/js/libs/api-helpers';
import dayjs from '@/js/libs/dayjs';
import type { DateRangeType, DateType as PickerDateType } from '@/js/libs/ui/src/Form/DatePicker/types';

import type { ParamsValidator } from 'src/components/RouteParamsValidator';
import { DATE_PARAMETER_FORMAT, DATE_PARAMETER_FORMAT_REG_EXP } from 'src/constants';
import type { BroadcastRouteParams } from './types';
import { BroadcastPositionStage } from './types';

export const urlParameterValueSeparator = ',';

const VALID_STAGES = Object.values(BroadcastPositionStage);

export const validateBroadcastPositionStages: ParamsValidator<BroadcastRouteParams> = ({ stage }) => VALID_STAGES.includes(stage);

export const toRequestParameterDate = (date: PickerDateType): DateType | undefined => (date ? toDateType(dayjs(date)) : undefined);

export const toSearchParameterDate = (date: PickerDateType): string | undefined =>
  date ? dayjs(date).format(DATE_PARAMETER_FORMAT) : undefined;

const isValidSearchParameterDate = (date?: string): boolean =>
  date ? DATE_PARAMETER_FORMAT_REG_EXP.test(date) && dayjs(date).format(DATE_PARAMETER_FORMAT) === date : false;

export const toDateRangeFilterGroupedValue = (value: string | null): DateRangeType | null => {
  const stringValues = value?.split(urlParameterValueSeparator);

  if (stringValues && stringValues.length > 0) {
    const [startDate, endDate] = stringValues;
    const validStartDate = isValidSearchParameterDate(startDate) ? dayjs(startDate).toDate() : null;
    const validEndDate = validStartDate && isValidSearchParameterDate(endDate) ? dayjs(endDate).toDate() : null;

    return validStartDate || validEndDate ? [validStartDate, validEndDate] : null;
  }

  return null;
};
